import Navbar from "@/components/base/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import ArticleGrid from "./components/ArticleGrid";
import { faqItems } from "@/mocks/categories";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuy.yachts";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": `${siteUrl}/`,
      "name": "ACBuySpreadsheet – The Smartest Product Tracking Spreadsheet System in 2026",
      "description": "Discover ACBuySpreadsheet – a powerful spreadsheet-based product tracking system designed for faster, smarter buying decisions. Track, compare, and manage products instantly with the next-generation shopping intelligence tool in 2026.",
      "inLanguage": "en",
      "isPartOf": {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": `${siteUrl}/`,
        "name": "ACBuy Spreadsheet",
        "description": "The smartest spreadsheet-based product tracking system for smarter buying decisions."
      },
      "about": {
        "@type": "Thing",
        "name": "ACBuy Spreadsheet System",
        "description": "A next-generation spreadsheet-based product tracking and comparison system for online shoppers."
      },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg"
      }
    },
    {
      "@type": "FAQPage",
      "@id": `${siteUrl}/#faq`,
      "url": `${siteUrl}/`,
      "mainEntity": faqItems.map((item) => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    }
  ]
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <Hero />
      <FeatureGrid />
      <AboutSection />
      <CategoryGrid />
      <CTASection />
      <ArticleGrid />
      <TestimonialSection />
      <Footer />
    </main>
  );
}